import type {
  StylistProfile,
  StylistProfileInput,
  StylistProfileResponse,
  StylistReplyResponse,
  StylistThread,
  StylistThreadsResponse,
} from '../../shared/stylist';
import { readError } from './api';

async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
    },
    ...init,
  });
  if (!response.ok) throw new Error(await readError(response));
  return (await response.json()) as T;
}

export async function getStylist(): Promise<StylistThreadsResponse> {
  return request('/api/stylist');
}

export async function askStylist(message: string, threadId?: string): Promise<StylistThread> {
  return (
    await request<StylistReplyResponse>('/api/stylist', {
      method: 'POST',
      body: JSON.stringify({ message, ...(threadId ? { threadId } : {}) }),
    })
  ).thread;
}

export async function deleteStylistThread(id: string): Promise<void> {
  await request(`/api/stylist/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export async function saveStylistProfile(input: StylistProfileInput): Promise<StylistProfile> {
  return (
    await request<StylistProfileResponse>('/api/stylist/profile', {
      method: 'PUT',
      body: JSON.stringify(input),
    })
  ).profile;
}

export async function deleteStylistProfile(): Promise<StylistProfile> {
  return (
    await request<StylistProfileResponse>('/api/stylist/profile', {
      method: 'DELETE',
    })
  ).profile;
}
